import { UserRole } from "@/models/user.generalkey";
export const MENU_ITEMS = [
    // TABLEAU DE BORD
    {
        id: 'dashboard-admin',
        title: 'sidebar.dashboard',
        icon: 'flaticon-more-1',
        to: '/home',
        roles: [UserRole.ADMIN]
    },
    {
        id: 'dashboard-franchise',
        title: 'sidebar.dashboard',
        icon: 'flaticon-more-1',
        to: '/admin-dashboard',
        roles: [UserRole.FRANCHISE]
    },
    // POS
    {
        subTitle: 'sidebar.pos',
        roles: [UserRole.RESTAURANT, UserRole.ADMIN]
    },
    {
        id: 'pos-system',
        title: 'sidebar.posSystem',
        icon: 'flaticon-shopping-cart-2',
        to: '/ajout-commande',
        roles: [UserRole.RESTAURANT, UserRole.ADMIN]
    },
    // VENTE
    {
        subTitle: 'sidebar.sales',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT]
    },
    {
        id: 'sales',
        title: 'sidebar.sales',
        icon: 'flaticon-trolley-cart',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT],
        children: [
            { id: 'orders', title: 'sidebar.orders', to: '/order-list' },
            { id: 'daily-closures', title: 'Clôtures de caisse', to: '/clotures-journalieres', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            {
                id: 'sales-report',
                title: 'sidebar.salesReport',
                to: '/rapport-vente',
                roles: [UserRole.ADMIN, UserRole.FRANCHISE]
            },
            { id: 'advanced-analytics', title: 'sidebar.advancedAnalytics', to: '/rapport-vente-avance' },
            {
                id: 'deleted-orders',
                title: 'Commandes Supprimées',
                to: '/commandes-supprimees',
                roles: [UserRole.ADMIN, UserRole.FRANCHISE]
            }
        ]
    },
    // GESTION
    {
        subTitle: 'sidebar.management',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE]
    },
    {
        id: 'management',
        title: 'sidebar.management',
        icon: 'flaticon-price-tag-2',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT],
        children: [
            { id: 'opening-hours', title: 'sidebar.openingHours', to: '/opening-hours', roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT] },
            {
                id: 'closures',
                title: 'sidebar.closures',
                to: '/special-closures',
                roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT]
            },
            { id: 'payment-methods', title: 'sidebar.paymentMethods', to: '/payment-methods' },
            { id: 'categories', title: 'sidebar.categories', to: '/categorie-list' },
            { id: 'ingredients', title: 'sidebar.ingredients', to: '/ingredient-list' },
            { id: 'ingredient-types', title: 'sidebar.ingredientTypes', to: '/ingredient-type-list', roles: [UserRole.FRANCHISE] },
            { id: 'personalization', title: 'sidebar.managmentCategories', to: '/ingredient-category-list', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'supplements', title: 'sidebar.supplements', to: '/supplement-list', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'supplement-types', title: 'sidebar.supplementTypes', to: '/supplement-type-list', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'features', title: 'sidebar.features', to: '/feature-list', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'products', title: 'sidebar.products', to: '/product-list' },
            { id: 'coupons', title: 'sidebar.coupon', to: '/list-coupon', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'ingredient-bases', title: 'sidebar.ingredientBases', to: '/ingredient-base-list', roles: [UserRole.FRANCHISE] },
            {
                id: 'referral',
                title: 'sidebar.referral',
                to: '/parrainage',
                roles: [UserRole.FRANCHISE],
                condition: (ctx) => ctx.loyaltyMode !== 'MCDO'
            },
            {
                id: 'loyalty',
                title: 'sidebar.loyalty',
                to: '/fidelite',
                roles: [UserRole.FRANCHISE],
                condition: (ctx) => ctx.loyaltyMode !== 'MCDO'
            },
            {
                id: 'loyalty-products',
                title: 'Récompenses Fidélité',
                to: '/fidelite-produits',
                roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT],
                condition: (ctx) => ctx.loyaltyMode === 'MCDO'
            },
        ]
    },
    // APPLICATIONS
    // {
    //   id: 'applications',
    //   title: 'sidebar.applications',
    //   icon: 'flaticon-menu-1',
    //   children: [
    //     { id: 'omnesight-ai', title: 'sidebar.omnesightAi', to: '/omnesight-ai' }
    //   ]
    // },
    // CRM
    {
        subTitle: 'CRM',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT]
    },
    {
        id: 'crm',
        title: 'CRM',
        icon: 'flaticon-rocket',
        children: [
            { id: 'customers', title: 'sidebar.customers', to: '/customer-list' },
            { id: 'email-campaigns', title: 'sidebar.emailCampaigns', to: '/campagne-list', roles: [UserRole.FRANCHISE] },
            { id: 'marketing-dashboard', title: 'Analytique Marketing', to: '/marketing-dashboard', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'attribution', title: 'Attribution', to: '/marketing/attribution', roles: [UserRole.ADMIN, UserRole.FRANCHISE] },
            { id: 'push-notifications', title: 'sidebar.pushNotifications', to: '/notifications-sending', roles: [UserRole.FRANCHISE] },
            { id: 'automated-messages', title: 'sidebar.automatedMessages', to: '/marketing/messages-automatiques', roles: [UserRole.FRANCHISE] },
            { id: 'recommendations', title: 'Recommandations', to: '/marketing/upsell', roles: [UserRole.FRANCHISE] },
            { id: 'loyalty-strategy', title: 'Stratégie Fidélité', to: '/fidelite-strategie', roles: [UserRole.FRANCHISE] },
            { id: 'loyalty-report', title: 'sidebar.loyaltyReport', to: '/loyalty-report', roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT] },
            { id: 'referral-report', title: 'sidebar.referralReport', to: '/rapport-parrainage', roles: [UserRole.ADMIN, UserRole.FRANCHISE, UserRole.RESTAURANT] }
        ]
    },
    // SOCIAL MEDIA
    {
        subTitle: 'Media Social',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE]
    },
    {
        id: 'social-marketing',
        title: 'Media Social',
        icon: 'flaticon-chat-1',
        children: [
            { id: 'social-feed', title: 'Flux (Live)', to: '/social/feed' },
            { id: 'social-posts', title: 'Posts', to: '/social/posts' },
            { id: 'social-chat', title: 'Messages & Commentaires', to: '/social/chat' },
            { id: 'social-config', title: 'Configuration', to: '/social/configuration' }
        ]
    },
    // CONTENU & ENGAGEMENT
    {
        subTitle: 'sidebar.marketingContent',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE]
    },
    {
        id: 'marketing-content',
        title: 'sidebar.customElements',
        icon: 'flaticon-technical-support',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE],
        children: [
            { id: 'blog', title: 'sidebar.blog', to: '/marketing/blog' },
            { id: 'faq', title: 'sidebar.faq', to: '/marketing/faq' },
            { id: 'gallery', title: 'sidebar.gallery', to: '/marketing/gallery' },
            { id: 'traiteur', title: 'sidebar.traiteur', to: '/marketing/traiteur' },
            { id: 'gift-cards', title: 'sidebar.giftCards', to: '/marketing/gift-cards' },
            { id: 'reviews', title: 'Témoignages', to: '/marketing/reviews' },
            { id: 'marketing-settings', title: 'sidebar.marketingSettings', to: '/marketing/settings', class: 'fw-bold' },
            //{ id: 'dynamic-pages', title: 'Pages Dynamiques', to: '/marketing/pages', class: 'fw-bold' },
            // { id: 'forms', title: 'Gestion des Formulaires', to: '/marketing/forms', class: 'fw-bold' },
        ]
    },
    // RESTAURANTS & USERS
    {
        subTitle: 'sidebar.accounts',
        roles: [UserRole.FRANCHISE]
    },
    {
        id: 'restaurants',
        title: 'sidebar.restaurants',
        icon: 'flaticon-bookmark',
        roles: [UserRole.FRANCHISE],
        children: [
            { id: 'restaurant-list', title: 'sidebar.restaurantList', to: '/restaurant-list' },
            { id: 'delivery-zones', title: 'sidebar.deliveryZones', to: '/delivery-zones' }
        ]
    },
    {
        id: 'users',
        title: 'sidebar.users',
        icon: 'flaticon-users-group',
        roles: [UserRole.FRANCHISE],
        children: [
            { id: 'user-list', title: 'sidebar.userList', to: '/utilisateur-list' }
        ]
    },
    // SETTINGS
    {
        subTitle: 'Settings',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE]
    },
    {
        id: 'settings',
        title: 'Settings',
        icon: 'flaticon-settings',
        roles: [UserRole.ADMIN, UserRole.FRANCHISE],
        children: [
            { id: 'settings-general', title: 'Général', to: '/settings/general' },
            { id: 'settings-theme', title: 'Web Design', to: '/settings/theme' },
            { id: 'settings-integrations', title: 'Intégrations', to: '/settings/integrations' }
        ]
    },
    // LOGOUT
    {
        id: 'logout',
        title: 'sidebar.logout',
        icon: 'flaticon-logout',
        to: '',
        click: 'logout'
    }
];
